import styled from "styled-components";


export const OverflowSpan = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    width: 100%;
    word-break: break-all;
    overflow: hidden;
    margin: 10px;
`;

export const DivFlex = styled.div`
    display: flex;
    align-items: center;
`;
